import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/auth/user.model';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-product-subscriptions',
    templateUrl: './product-subscriptions.component.html',
    styleUrls: ['./product-subscriptions.component.scss'],
    standalone: false
})
export class ProductSubscriptionsComponent implements OnInit {
  showSearch: boolean;
  searchForm!: FormGroup;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  subscriptionsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null
  };

  searchValue = "";
  user: User;
  productId: any;
  productName: any;

  constructor(private router: Router, public dataService: DataService, private authService: AuthService,
              private route: ActivatedRoute,
              public utils: UtilsService,
              private dialog: MatDialog
              ) {
                this.showSearch = false;
                this.user = this.authService.getUserData();
                this.userID = this.user.id;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
                this.route.queryParams.subscribe((params: Params) => {
                if (!this.isEmpty(params)) {
                this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                this.pageSize = params.pageSize ? params.pageSize : 10;
                this.searchValue =  params.searchValue ? params.searchValue : "";
                }
                this.getSubscriptions();
                });
              }
  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
    secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/subscriptions',
    });
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }
    
    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  getSubscriptions() {
    this.dataService.get('Product/RetrieveProductSubscriptions/' + this.productId + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.subscriptionsList = [];
        const subscriptionsData = data.data.records;
        this.totalSize = data.data.count;
        subscriptionsData.forEach((subscribtionData: any) => {
          this.subscriptionsList.push(subscribtionData);
        });
        if (subscriptionsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
          this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/subscriptions'], { queryParams: this.queryParams });
        }
      }
    });
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
    '/subscriptions'], { queryParams: this.queryParams });
  }
  handleSearchClick() {
    if (this.showSearch && this.subscriptionsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }
  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/subscriptions'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue
    };
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/subscriptions'], { queryParams: this.queryParams });
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/distributor-dark.png'
        : '../../../assets/images/distributor-light.png';
    });
  }

  deleteSubscription(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'subscription',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('ProductAccessRequest/DeleteProductAccessRequest/' + this.productId + '/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.getSubscriptions();
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Subscription deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  truncateName(firstName: string, lastName: string) {
    let fullName = firstName + ' ' + lastName;
    if (fullName.length  > 20) {
      fullName = fullName.slice(0, 20) + '...';
    }
    return fullName;
  }

}
